import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "./authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

// 🔥 initialize once
export const initializeAuth = async () => {
    await msalInstance.initialize();

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }
};

// 🔥 get token (NO POPUP)
export const getAccessToken = async () => {
    await initializeAuth();

    let accounts = msalInstance.getAllAccounts();

    // if not logged → redirect login
    if (accounts.length === 0) {
        await msalInstance.loginRedirect(loginRequest);
        return;
    }

    try {
        const response = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        });

        const accessToken = response.accessToken;
        const email = response.account?.username;

        localStorage.setItem("jwtToken", accessToken || "");
        localStorage.setItem("user", email || "");

        return { accessToken, email };
    } catch (error) {
        console.error("Token error:", error);
    }
};

// logout
export const logout = async () => {
    await msalInstance.logoutRedirect();
};